module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_gifu-28537ff22fce87940a401bf38f428563.png";